import { Reveal } from './Reveal';
import { ArrowLinkIcon } from './icons';

export function SecuritySection() {
  return (
    <section style={{ maxWidth: 1400, margin: '0 auto', padding: '0 24px 40px' }}>
      <div
        style={{
          background: '#f7f8fc', borderRadius: 15, padding: '40px 48px',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 32, flexWrap: 'wrap',
        }}
      >
        <Reveal x={-50} y={0} style={{ flex: '1 1 300px', maxWidth: 320 }}>
          <h2 style={{ margin: '0 0 16px', fontFamily: 'Inter, sans-serif', fontWeight: 700, fontSize: 24, color: '#000', lineHeight: 1.3 }}>
            Security &amp; Compliance you can trust
          </h2>
          <p style={{ margin: '0 0 20px', fontFamily: 'Inter, sans-serif', fontWeight: 500, fontSize: 14, color: '#4c5876', lineHeight: 1.5 }}>
            We take the security of your data seriously. Our platform is built with enterprise-grade security and fully compliant with industry standards.
          </p>
          <a href="#" style={{ display: 'inline-flex', alignItems: 'center', gap: 6, textDecoration: 'none', fontSize: 14, fontFamily: 'Inter, sans-serif', fontWeight: 600, color: '#014ed2' }}>
            Explore documentation <ArrowLinkIcon size={18} />
          </a>
        </Reveal>

        <Reveal x={50} y={0} delay={0.3} style={{ display: 'flex', gap: 24, alignItems: 'center', flexWrap: 'wrap' }}>
          <div style={{ background: '#fff', borderRadius: 10, boxShadow: '0 0 6.3px rgba(0,0,0,0.09)', width: 137, height: 137, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 12 }}>
            <img src="/landing/security-badge-1.png" alt="ISO certified" width={93} height={93} style={{ objectFit: 'contain' }} />
          </div>
          <div style={{ background: '#fff', borderRadius: 10, boxShadow: '0 0 6.3px rgba(0,0,0,0.09)', width: 137, height: 137, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 12 }}>
            <img src="/landing/security-badge-2.png" alt="NDPR compliant" width={110} height={38} style={{ objectFit: 'contain' }} />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
